<template>
  <div class="landing-page">
    <img
      v-if="isAuthenticated"
      src="@/assets/img/elipse-1.svg"
      alt="Elipse 1"
      class="elipse-1"
    />
    <img
      v-if="isAuthenticated"
      src="@/assets/img/elipse-2.svg"
      alt="Elipse 2"
      class="elipse-2"
    />
    <section class="no-margin">
      <banners-carousel></banners-carousel>
    </section>
    <section class="welcome-section" v-if="!isAuthenticated">
      <h1 class="title">Seu Clube de prêmios!</h1>
      <div class="content">
        <img src="@/assets/img/products.svg" alt="Produtos" />
        <p>
          O Clube Venda e Ganhe é um portal para você acompanhar sua pontuação e
          converter em produtos ou dinheiro. Além de realizar treinamentos e
          ficar por dentro de todas as novidades das nossas marcas.
        </p>
      </div>
    </section>
    <section v-if="isAuthenticated">
      <informatives></informatives>
    </section>
    <section v-if="isAuthenticated">
      <products-featured></products-featured>
    </section>
    <section v-if="isAuthenticated">
      <trainings-carousel></trainings-carousel>
    </section>
  </div>
</template>

<script>
import BannersCarousel from '@/components/LandingPage/BannersCarousel.vue';
import Informatives from '@/components/LandingPage/Informatives.vue';
import ProductsFeatured from '@/components/LandingPage/ProductsFeatured.vue';
import TrainingsCarousel from '@/components/LandingPage/TrainingsCarousel.vue';

import TermVerificationService from '@/services/term-verification.service';

import AppTermVerificationModal from '@/components/Modal/TermVerificationModal.vue';
import { AUTH_LOGOUT } from '@/store/actions/auth';

export default {
  name: 'landing-page',
  components: {
    BannersCarousel,
    Informatives,
    ProductsFeatured,
    TrainingsCarousel,
  },
  methods: {
    showTermModal() {
      this.$buefy.modal.open({
        parent: this,
        component: AppTermVerificationModal,
        trapFocus: true,
        hasModalCard: true,
        onCancel: this.onCancel,
      });
    },
    loadTerm() {
      if (this.isAuthenticated) {
        TermVerificationService.get().then((response) => {
          if (!response.data) {
            this.showTermModal();
          }
        });
      }
    },
    onCancel() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$route.path !== '/' && this.$router.push('/');
      });
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'production') {
      this.$gtag.event('landing-page');
    }

    this.loadTerm();
  },
};
</script>

<style lang="scss" scoped>
section:not(.no-margin) {
  margin-top: 48px;
}

section.welcome-section {
  text-align: center;

  h1.title {
    color: var(--color-primary);
  }

  .content {
    display: inline-flex;
    max-width: 800px;

    img {
      margin-right: 32px;
    }

    p {
      margin-top: 32px;
      text-align: left;
      font-size: 1.1em;
      color: var(--text-color-light);
    }
  }
}

.elipse-1 {
  position: absolute;
  right: 0;
  top: 40vh;
  z-index: -1;
}

.elipse-2 {
  position: absolute;
  left: 0;
  top: 90vh;
  z-index: -1;
}

@media (max-width: 992px) {
  .welcome-section {
    padding: 0 2em;

    .content {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
